let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dkw3i")).then(() => parcelRequire('hWHpM'));